import { render, staticRenderFns } from "./Speedometer.vue?vue&type=template&id=876ddc7a&"
import script from "./Speedometer.vue?vue&type=script&lang=js&"
export * from "./Speedometer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports